class ElementWidthDirective {
    constructor($window, $timeout) {
        this.restrict = 'A';
        this.$window = $window;
        this.$timeout = $timeout;
        this.deffered = null;
    }

    link(scope, element, attrs, controllers) {
        const container = element[0];
        const offset = parseInt(attrs.offset) || 0;
        const max = parseInt(attrs.max) || Number.MAX_SAFE_INTEGER;
        scope.elementWidth = Math.min(container.clientWidth - offset, max);

        this.$timeout(() => {
            const newWidth = Math.min(container.clientWidth - offset, max);
            
            if (newWidth != scope.elementWidth) scope.elementWidth = newWidth;
        }, 1500);

        const onResize = () => {
            scope.elementWidth = Math.min(container.clientWidth - offset, max);
            scope.$apply();

            if (this.deffered) this.$timeout.cancel(this.deffered);

            this.deffered = this.$timeout(() => {
                const newWidth = Math.min(container.clientWidth - offset, max);

                if (newWidth != scope.elementWidth) scope.elementWidth = newWidth;
            }, 500);
        }

        angular.element(this.$window).on('resize', onResize);

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', onResize);
        });
    }

    static directiveFactory($window, $timeout) {
        'ngInject';
        return new ElementWidthDirective($window, $timeout);
    }
}

export default ElementWidthDirective;